import React, { useContext, useCallback, useState } from "react";
import { Tabs, LegacyCard as Card } from "@shopify/polaris";
import { ProductProvider } from "app/productLake/modules/generic/context";

// import context
import { PrivateContext } from "lib/context/privateContext";

// import Hoc
import { withErrorBoundary } from "lib/hoc";

// import prop
import { tabProp } from "app/productLake/modules/generic/propTypes";
import addData, { getPanelComponent } from "app/productLake/modules/provider/features/add/config/addData";

const ProductTabs = (props) => {
  const { setBanner } = props;
  const { cms } = useContext(PrivateContext);
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback((selectedTabIndex) => setSelected(selectedTabIndex), []);
  return (
    <>
      <Card>
        <Tabs tabs={addData(cms).tabs} selected={selected} setBanner={setBanner} />
      </Card>
      <br />
      <ProductProvider
        value={{
          setBanner,
          handleTabChange,
        }}
      >
        <div className="productComponent">{getPanelComponent(selected, cms)}</div>
      </ProductProvider>
    </>
  );
};

ProductTabs.propTypes = tabProp.type;

export default withErrorBoundary(ProductTabs);
